import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { IconSize } from '@/models/icon-types';
import { OptionIcon } from '@/models/select-props-interfaces';
import { computed, ref } from 'vue';

export interface FormButtonProps {
  label: string;
  onClick: () => Promise<void> | void;
  type?: 'primary' | 'secondary' | 'destructive';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  leftIcon?: OptionIcon;
  rightIcon?: OptionIcon;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormButton',
  props: {
    label: {},
    onClick: {},
    type: { default: 'primary' },
    size: { default: 'medium' },
    className: {},
    leftIcon: {},
    rightIcon: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const loading = ref(false);

const handleClick = async () => {
  if (props.onClick) {
    try {
      loading.value = true;
      await props.onClick();
    } catch (error) {
      console.error('Error in button click handler:', error);
    } finally {
      loading.value = false;
    }
  }
};

const iconSize = computed<IconSize>(() => {
  switch (props.size) {
    case 'small':
      return 'body-xs';
    case 'medium':
      return 'body-s';
    case 'large':
      return 'body-m';
    default:
      return 'body-s';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['custom-button', _ctx.type, _ctx.size, _ctx.className, { loading: loading.value }]),
    disabled: _ctx.disabled || loading.value,
    onClick: handleClick,
    type: "button"
  }, [
    (_ctx.leftIcon)
      ? (_openBlock(), _createBlock(AppIcon, {
          key: 0,
          name: _ctx.leftIcon.name,
          size: _ctx.leftIcon.size ?? iconSize.value
        }, null, 8, ["name", "size"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.label) + " ", 1),
    (_ctx.rightIcon)
      ? (_openBlock(), _createBlock(AppIcon, {
          key: 1,
          name: _ctx.rightIcon.name,
          size: _ctx.rightIcon.size ?? iconSize.value
        }, null, 8, ["name", "size"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})